import { getCdnBaseUrl } from '@/config/env-config';

const NEWCORE_APP_ICON_PATH = '/icons/newcore_app_icon.svg';

export function getNewcoreAppIconUrl() {
  return `${getCdnBaseUrl()}${NEWCORE_APP_ICON_PATH}`;
}
